<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputSpecialRequirements" });
import { InputText } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
</script>

<InputText
    bind:value
    placeholder = 'Type here any other relevant information about this location.'
    label = 'Special Requirements'
    name = 'address.specialRequirements'
    { isDisabled }
    { isReadonly }
    { isRequired }
/>